import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "c-global-presence-section__header" }
const _hoisted_3 = {
  key: 0,
  class: "c-global-presence-section__cards"
}
const _hoisted_4 = { class: "c-global-presence-section__media" }
const _hoisted_5 = { class: "c-global-presence-section__card-body" }
const _hoisted_6 = ["href", "target", "rel", "aria-label"]

import { computed } from 'vue';
import { RichText, Text as JssText } from '@sitecore-jss/sitecore-jss-vue';
import AdaptiveMedia from '@/elements/AdaptiveMedia.vue';
import utils from '@/utils';
import type {
  GlobalPresenceSectionCardFields,
  GlobalPresenceSectionFields,
} from '@/types/components/GlobalPresenceSection';
import type { ScItem } from '@/types/sitecore';

interface GlobalPresenceSectionProps {
  fields: GlobalPresenceSectionFields;
  rendering?: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalPresenceSection',
  props: {
    fields: {},
    rendering: {}
  },
  setup(__props: any) {

const props = __props;

const fields = computed(() => props.fields);
const rendering = computed(() => props.rendering);

const cards = computed(() => fields.value?.cards ?? []);
const backgroundSrc = computed(() => fields.value?.backgroundImage?.value?.src || '');

const rootClass = computed(() =>
  utils.overall.baseComClass(props.fields, 'c-global-presence-section')
);
const rootStyle = computed(() => {
  const result = utils.overall.baseComStyle(props.fields);
  return { backgroundImage: `url(${backgroundSrc.value})`, ...result };
});

const hasCardMedia = (card: ScItem<GlobalPresenceSectionCardFields>) => {
  const mediaFields = card.fields?.video?.fields;

  return !!(
    mediaFields?.desktopImage?.value?.src ||
    mediaFields?.mobileImage?.value?.src ||
    mediaFields?.desktopVideo?.value?.src ||
    mediaFields?.desktopVideo?.value?.href ||
    mediaFields?.mobileVideo?.value?.src ||
    mediaFields?.mobileVideo?.value?.href
  );
};
const getCardMediaField = (card: ScItem<GlobalPresenceSectionCardFields>) => card.fields?.video;

const getCardLink = (card: ScItem<GlobalPresenceSectionCardFields>) => {
  const value = card.fields?.link?.value || {};
  return {
    href: value.href || '',
    target: value.target,
    label: value.text || value.title || card.fields?.title?.value || 'View details',
  };
};

return (_ctx: any,_cache: any) => {
  const _component_JssRichText = _resolveComponent("JssRichText")!
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (fields.value)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(rootClass.value),
        style: _normalizeStyle(rootStyle.value),
        id: rendering.value?.dataSource
      }, [
        _createVNode(_component_ContentGrid, {
          "desktop-default-grid": [2, 20],
          "mobile-default-grid": [1, 14]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_JssRichText, {
                class: "c-global-presence-section__title",
                field: fields.value?.title,
                tag: "h2"
              }, null, 8, ["field"]),
              (fields.value.description?.value)
                ? (_openBlock(), _createBlock(_unref(RichText), {
                    key: 0,
                    class: "c-global-presence-section__description",
                    field: fields.value.description
                  }, null, 8, ["field"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_ContentGrid, {
          "desktop-default-grid": [3, 18],
          "mobile-default-grid": [1, 14]
        }, {
          default: _withCtx(() => [
            (cards.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards.value, (card) => {
                    return (_openBlock(), _createElementBlock("article", {
                      key: card.id,
                      class: "c-global-presence-section__card"
                    }, [
                      _createElementVNode("div", _hoisted_4, [
                        (hasCardMedia(card))
                          ? (_openBlock(), _createBlock(AdaptiveMedia, {
                              key: 0,
                              field: getCardMediaField(card),
                              ratio: 1.78,
                              "show-play-button": true,
                              autoplay: false,
                              loop: false,
                              controls: true,
                              "has-controls": true,
                              "is-background": ""
                            }, null, 8, ["field"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        (card.fields?.title?.value)
                          ? (_openBlock(), _createBlock(_unref(JssText), {
                              key: 0,
                              class: "c-global-presence-section__card-title",
                              field: card.fields.title,
                              tag: "h3"
                            }, null, 8, ["field"]))
                          : _createCommentVNode("", true),
                        (card.fields?.description?.value)
                          ? (_openBlock(), _createBlock(_unref(RichText), {
                              key: 1,
                              class: "c-global-presence-section__card-description",
                              field: card.fields.description
                            }, null, 8, ["field"]))
                          : _createCommentVNode("", true),
                        (getCardLink(card).href)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 2,
                              class: "c-global-presence-section__card-link",
                              href: getCardLink(card).href,
                              target: getCardLink(card).target,
                              rel: getCardLink(card).target === '_blank' ? 'noopener noreferrer' : undefined,
                              "aria-label": getCardLink(card).label
                            }, null, 8, _hoisted_6))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 14, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})